import React from "react";
import Head from "next/head";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import {
  createStyles,
  Theme,
  makeStyles,
  useTheme,
} from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import { useQuery, gql } from "@apollo/client";

import AppBar from "@Components/appBar/appBar";
import SummaryCard, { ISOToLocalString } from "@Components/posts/summaryCard";
import HeaderBlock from "@Components/posts/headerBlock";
import Section from "@Components/posts/section";
import Footer from "@Components/common/footer";
import client from "@Config/graphCMSInit";
import SEO from "@Components/common/seo";
import DisplayAd from "@Components/ads/displayAd";

const GET_ARTICLES = gql`
  query {
    articles(first: 100, orderBy: createdAt_DESC) {
      slug
      title
      description
      createdAt
      gallery {
        url(
          transformation: {
            image: { resize: { width: 400, height: 400, fit: clip } }
            document: { output: { format: webp } }
          }
        )
      }
    }
  }
`;

const useStyles = makeStyles((theme: Theme) => createStyles({}));

export const getStaticProps = async ({ locale }: any) => {
  const cmsQuery = await client.query({
    query: GET_ARTICLES,
  });

  return {
    props: {
      data: cmsQuery.data,
      ...(await serverSideTranslations(locale, ["common"])),
    },
  };
};

interface StaticProps {
  data: {
    articles: {
      slug: string;
      title: string;
      description: string;
      createdAt: string;
      gallery: { url: string }[];
    }[];
  };
}

export default function Home({ data }: StaticProps) {
  const { t: t_common } = useTranslation("common");

  const router = useRouter();
  const classes = useStyles();

  return (
    <React.Fragment>
      <SEO
        pageTitle="新着記事"
        pageImg={
          data.articles[0]?.gallery[0]
            ? data.articles[0].gallery[0].url
            : undefined
        }
      />

      <AppBar>
        <Section>
          {data ? (
            <React.Fragment>
              <HeaderBlock
                title={`新着記事: ${data.articles.length}件`}
                subtitle="それぞれの宿にある建物を調査！（先行公開）
                宿の建物ひとつひとつに、数えきれないほどの魅力があります。
                それらを、なるべく拾い集めたい…と記事にしました。"
              />

              <Grid container spacing={3}>
                {data.articles.map((item, i) => {
                  return (
                    <Grid item sm={6} xs={12} key={i}>
                      <SummaryCard
                        title={item.title}
                        description={item.description}
                        image={item.gallery[0] ? item.gallery[0].url : ""}
                        date={ISOToLocalString(item.createdAt, router.locale)}
                        link={`/posts/${item.slug}`}
                      />
                    </Grid>
                  );
                })}
                <Grid item sm={6} xs={12} key="a">
                  <DisplayAd variant="square" />
                </Grid>
              </Grid>
            </React.Fragment>
          ) : null}
        </Section>

        <Footer />
      </AppBar>
    </React.Fragment>
  );
}
